/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invalid_Product_CategoryInputs */

const vi_error_invalid_product_category = /** @type {(inputs: Error_Invalid_Product_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục sản phẩm không hợp lệ. Tải lại trang rồi chọn lại danh mục.`)
};

/**

* @param {Error_Invalid_Product_CategoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_invalid_product_category = /** @type {((inputs?: Error_Invalid_Product_CategoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invalid_Product_CategoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_invalid_product_category(inputs)
});